var React = require('react');

function ChevronRightWhite (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0.792893 17.7071C0.402369 17.3166 0.402369 16.6834 0.792894 16.2929L8.08579 9L0.792895 1.7071C0.40237 1.31658 0.40237 0.683417 0.792895 0.292892C1.18342 -0.0976323 1.81658 -0.0976322 2.20711 0.292892L10.2071 8.29289C10.3946 8.48043 10.5 8.73478 10.5 9C10.5 9.26522 10.3946 9.51957 10.2071 9.70711L2.20711 17.7071C1.81658 18.0976 1.18342 18.0976 0.792893 17.7071Z","fill":"white"}));
}

ChevronRightWhite.defaultProps = {"width":"11","height":"18","viewBox":"0 0 11 18","fill":"none"};

module.exports = ChevronRightWhite;

ChevronRightWhite.default = ChevronRightWhite;
